import { render, staticRenderFns } from "./TakeOutFromLaboratoryModal.vue?vue&type=template&id=4c58bf4b&"
import script from "./TakeOutFromLaboratoryModal.vue?vue&type=script&lang=js&"
export * from "./TakeOutFromLaboratoryModal.vue?vue&type=script&lang=js&"
import style0 from "./TakeOutFromLaboratoryModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports